import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { YMaps } from 'react-yandex-maps';
import { LANG, getYandexMapsLang } from './config';
import './fonts';
import './fonts.scss';

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <YMaps query={{ load: 'util.bounds', lang: getYandexMapsLang(LANG) }}>
                <App />
            </YMaps>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('where-to-buy-root')
);
